import {useTranslation} from 'react-i18next';
import Header from './components/Header';
import RolesTable from './components/RolesTable';
import AddEditRoleDialog from './components/AddEditRoleDialog';

function RolesMain() {
  const {i18n} = useTranslation();
  const isHebrew = i18n.language === 'heb';

  return (
    <>
      <div
        className={`flex-1 min-h-0 flex flex-col ${
          isHebrew ? 'rounded-tl-[32px]' : 'rounded-tr-[32px]'
        }`}>
        {/* Header */}
        <Header />

        <RolesTable />
      </div>

      <AddEditRoleDialog />
    </>
  );
}

export default RolesMain;
